import SuperRepository from '../superRepository'

export default new (class AdvertiserCountryRepository extends SuperRepository {
  baseUri() {
    return 'advertiser_country'
  }
})()